"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listReducer = exports.ListReducerActionType = void 0;
var tslib_1 = require("tslib");
var ListReducerActionType;
(function (ListReducerActionType) {
    ListReducerActionType[ListReducerActionType["ADD"] = 0] = "ADD";
    ListReducerActionType[ListReducerActionType["UPDATE"] = 1] = "UPDATE";
    ListReducerActionType[ListReducerActionType["DELETE"] = 2] = "DELETE";
    ListReducerActionType[ListReducerActionType["RESET"] = 3] = "RESET";
    ListReducerActionType[ListReducerActionType["REVERSE"] = 4] = "REVERSE";
})(ListReducerActionType = exports.ListReducerActionType || (exports.ListReducerActionType = {}));
function listReducer(state, action) {
    switch (action.type) {
        case ListReducerActionType.ADD:
            return tslib_1.__spreadArrays(state, [action.element]);
        case ListReducerActionType.DELETE:
            state.splice(action.index, 1);
            return tslib_1.__spreadArrays(state);
        case ListReducerActionType.RESET:
            return [];
        case ListReducerActionType.REVERSE:
            return state.reverse();
        case ListReducerActionType.UPDATE:
            return action.list;
        default:
            return state;
    }
}
exports.listReducer = listReducer;
//# sourceMappingURL=list-reducer.js.map